import { apiRequest } from '../services/apiClient';

/**
 * Attendance Service
 * Handles all attendance-related API calls
 */
export const attendanceService = {
  /**
   * Get attendance report
   * @param {Object} params - Report parameters
   * @param {string} params.startDate - Start date (YYYY-MM-DD)
   * @param {string} params.endDate - End date (YYYY-MM-DD)
   * @param {number} params.tenantId - Tenant ID (optional)
   * @param {number} params.categoryId - Category ID (optional)
   * @returns {Promise} API response
   */
  getAttendanceReport: async (params) => {
    try {
      // Gateway routing:
      // - Gateway context-path: /gateway
      // - Gateway routes /gateway/login/** to login service (port 8081) with StripPrefix=1
      // - Login service context-path: /login
      // - Controller: @RequestMapping("/attendance") and @PostMapping("/report")
      // So the full path: /gateway/login/attendance/report
      // Gateway strips /gateway → forwards /login/attendance/report to login service
      // Login service handles /login/attendance/report (context + controller + method)
      const response = await apiRequest('/gateway/login/attendance/report', {
        method: 'POST',
        body: params  // apiRequest will stringify this automatically
      });
      return response;
    } catch (error) {
      console.error('Error fetching attendance report:', error);
      throw error;
    }
  },

  /**
   * Download attendance report as PDF
   * @param {Object} params - Report parameters
   * @param {string} params.startDate - Start date (YYYY-MM-DD)
   * @param {string} params.endDate - End date (YYYY-MM-DD)
   * @param {number} params.tenantId - Tenant ID (optional)
   * @param {number} params.categoryId - Category ID (optional)
   * @returns {Promise} Blob response
   */
  downloadAttendanceReportPDF: async (params) => {
    try {
      const token = sessionStorage.getItem('token') || sessionStorage.getItem('authToken');
      
      const BASE_URL = process.env.REACT_APP_BASE_URL || 
                       process.env.REACT_APP_GATEWAY_URL || 
                       process.env.REACT_APP_API_URL || 
                       'http://localhost:8080';

      // Gateway routes /gateway/login/** to login service
      // Path: /gateway/login/attendance/report/pdf
      const response = await fetch(`${BASE_URL}/gateway/login/attendance/report/pdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(params)
      });

      if (!response.ok) {
        throw new Error('Failed to download PDF');
      }

      const blob = await response.blob();
      return blob;
    } catch (error) {
      console.error('Error downloading attendance PDF:', error);
      throw error;
    }
  }
};

export default attendanceService;
